/* eslint-disable no-unused-vars */
import React from 'react';

import classes from './styles.module.scss';

export default function Frame({ frameUrl, style, width }) {
  return (
    <li
      className={classes.Frame}
      style={{
        minWidth: width,
        height: 65,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#f56d82', // More pink color
          borderRadius: '2px',
        }}
        draggable="false"
      />
    </li>
  );
}
